import React from "react";

const Elevation = ({ content, callback }) => {
  return (
    <div style={{ padding: 8, paddingTop: "0px", width: "100%" }}>
      <div
        style={{
          border: "1px solid #dedede",
          boxShadow: "0px 5px 8px #dedede",
          minHeight: 40,
          background: "white",
          borderRadius: 8,
          width: "100%",
          display: "block",
          padding: 8,
        }}
      >
        {content}
      </div>
      {callback && (
        <div
          style={{
            display: "block",
            cursor: "pointer",
            width: "98%",
            margin: "8px auto",
            height: 46,
            border: "1px solid #dedede",
            background: "#0099cc",
            color: "#fff",
            borderRadius: 100,
            fontWeight: "bold",
            lineHeight: "46px",
            textAlign: "center",

            fontSize: 16,
          }}
          onClick={callback}
        >
          Join or Login & Start Earning
        </div>
      )}
    </div>
  );
};

export default Elevation;
